import {
	RatchetMetricType,
	RatchetScheduleItem,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/Ratcheting/data.mock.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';

const formatTarget = (value: number | undefined, suffix: string) =>
	`≥${value?.toFixed(2) ?? ''}${suffix}`;

export const formatRatchetTierThreshold = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>,
	item: RatchetScheduleItem,
	metricType?: RatchetMetricType
): string => {
	if (metricType === RatchetMetricType.MOIC_AND_XIRR) {
		return tCapManage('securities.ratcheting.schedule.moic_and_xirr_threshold', {
			moicThreshold: formatTarget(item.threshold, 'x'),
			xirrThreshold: formatTarget(item.xirrThreshold, '%'),
		});
	}

	return formatTarget(item.threshold, metricType === RatchetMetricType.XIRR ? '%' : 'x');
};
